import { gql } from '@apollo/client';

export const ATOMIC_NCR = gql`
    mutation AtomicNCR($atomics: [NCRAtomic!]!) {
        atomicNCR(atomics: $atomics) {
            code
            success
            ncr {
                _id
                name
                capaDetails {
                    impactDescription
                    rootCause
                    _id
                }
                follower
                tags {
                    _id
                    name
                    colorCode
                    usedBy
                }
                resolvedFollower {
                    _id
                    name
                    firstName
                    profilePic {
                        thumbnail
                    }
                }
                resolvedNcrCreatedBy {
                    name
                    firstName
                    profilePic {
                        thumbnail
                    }
                }
                responsible {
                    responsibleID
                }
                resolvedResponsible {
                    _id
                    firstName
                    name
                    profilePic {
                        thumbnail
                    }
                }
                basicInformation {
                    externalReference
                    externalReferenceLocation
                    mediaInputs {
                        _id
                        mediaName
                        mediaLabel
                        mediaType
                        attachmentType
                    }
                    quantityData {
                        defected
                        total
                    }
                    failureCategory {
                        name
                        failureMode
                    }
                    description
                    customInputElements {
                        _id
                        customInputElementType
                        name
                        placeholder {
                            _id
                            language
                            value
                        }
                        label {
                            _id
                            language
                            value
                        }
                        choices {
                            value
                            label {
                                _id
                                language
                                value
                            }
                        }
                        required
                        min
                        max
                        value
                        defaultValue
                        currencyCode
                    }
                }
                reworks {
                    _id
                    processRoutings {
                        _id
                        processSteps {
                            _id
                            stepName {
                                value
                                language
                            }
                            stepNumber
                            stepStatus
                            responsible {
                                responsibleID
                            }
                            resolvedResponsible {
                                _id
                                name
                                firstName
                                profilePic {
                                    thumbnail
                                }
                            }
                            plannedDurations {
                                processTime
                            }
                            resolvedActualWorkplaces {
                                _id
                                workPlaceName {
                                    _id
                                    language
                                    value
                                }
                            }
                            workplaces {
                                _id
                                workplaceType
                                workPlaceName {
                                    _id
                                    language
                                    value
                                }
                            }
                            actualWorkplaces {
                                workplaceType
                                workPlaceName {
                                    _id
                                    language
                                    value
                                }
                            }
                            schedulingData {
                                dueDate
                            }
                        }
                    }
                    responsible {
                        responsibleID
                    }
                    resolvedResponsible {
                        name
                        firstName
                        _id
                    }
                    status
                    costAssignments {
                        value
                        currency
                        costCenter
                    }
                    workflowsIDs
                    resolvedWorkflows {
                        _id
                        name {
                            _id
                            language
                            value
                        }
                        workflowType
                        ncrID
                        resolvedWorkflowSteps {
                            _id
                            name {
                                _id
                                language
                                value
                            }
                            status
                            ncrID
                            workflowID
                            workflowStepTemplateID
                            availableActions {
                                _id
                                label {
                                    _id
                                    language
                                    value
                                }
                                caption {
                                    _id
                                    language
                                    value
                                }
                                trigger
                            }
                            dueDate
                        }
                    }
                }
                scraps {
                    _id
                    piecesToDeliver
                    piecesToRemake
                    discardedPieces
                    piecesInStock
                    comment
                    customInputElements {
                        _id
                        customInputElementType
                        name
                        placeholder {
                            _id
                            language
                            value
                        }
                        label {
                            _id
                            language
                            value
                        }
                        choices {
                            value
                            label {
                                _id
                                language
                                value
                            }
                        }
                        required
                        min
                        max
                        value
                        defaultValue
                        currencyCode
                    }
                    responsible {
                        responsibleID
                    }
                    resolvedResponsible {
                        name
                        firstName
                        profilePic {
                            thumbnail
                        }
                    }
                    status
                    costAssignments {
                        value
                        currency
                        costCenter
                    }
                    resolvedWorkflows {
                        _id
                        name {
                            _id
                            language
                            value
                        }
                        ncrID
                        resolvedWorkflowSteps {
                            _id
                            name {
                                _id
                                language
                                value
                            }
                            resolvedResponsible {
                                _id
                                firstName
                                name
                                profilePic {
                                    thumbnail
                                }
                            }
                            status
                            dueDate
                            ncrID
                            availableActions {
                                _id
                                label {
                                    _id
                                    language
                                    value
                                }
                                caption {
                                    _id
                                    language
                                    value
                                }
                                trigger
                            }
                        }
                    }
                }
                clearances {
                    _id
                    comments
                    clearanceRequest
                    clearanceResponse
                    responsible {
                        responsibleID
                    }
                    resolvedResponsible {
                        name
                        firstName
                        email
                        _id
                    }
                    status
                    costAssignments {
                        value
                        currency
                        costCenter
                    }
                    approvalStatus
                    customInputElements {
                        _id
                        customInputElementType
                        name
                        placeholder {
                            _id
                            language
                            value
                        }
                        label {
                            _id
                            language
                            value
                        }
                        choices {
                            value
                            label {
                                _id
                                language
                                value
                            }
                        }
                        required
                        min
                        max
                        value
                        defaultValue
                        currencyCode
                    }
                    workflowsIDs
                    resolvedWorkflows {
                        _id
                        name {
                            _id
                            language
                            value
                            formattedValue
                        }
                        ncrID
                        workflowType
                        resolvedWorkflowSteps {
                            _id
                            status
                            dueDate
                            workflowID
                            ncrID
                            workflowStepTemplateID
                            name {
                                _id
                                language
                                value
                                formattedValue
                            }
                            availableActions {
                                _id
                                trigger
                                caption {
                                    formattedValue
                                    value
                                    language
                                    _id
                                }
                                label {
                                    formattedValue
                                    value
                                    language
                                    _id
                                }
                            }
                        }
                    }
                }
                resolvedActivities {
                    activityActor {
                        actorType
                        actorID
                        externalActor
                    }
                    activityVerb
                    activityObject {
                        objectType
                        value
                        prevValue
                        valueObject {
                            priority
                            status
                            action
                            name
                        }
                        atMentions
                    }
                    activityTarget {
                        targetType
                        foreignID
                    }
                    createdAt
                    deleted
                    archived
                    organizations {
                        organizationID
                        teamsIDs
                    }
                    _id
                }
            }
        }
    }
`;
